import { Button, ButtonGroup } from "@mui/material";
import React from "react";

const ButtonGroupSelection = ({ idLables, value, setValue, sx, buttonSX }) => {
  return (
    <ButtonGroup sx={sx}>
      {idLables.map(obj => (
        <Button
          sx={buttonSX}
          key={obj.id}
          variant={value === obj.id ? "contained" : "outlined"}
          onClick={() => setValue(obj.id)}
          >{obj.label}</Button>
      ))}
    </ButtonGroup>
  );
}

export default ButtonGroupSelection;